import { ArrowDownward, ArrowUpward } from "@material-ui/icons";
import moment from "moment";
import { initialFilters, periods } from "../financeiro/constants";

export const contractsColumns = [
  {
    label: "Empresa",
    id: "company",
  },
  {
    label: "ID",
    id: "id",
  },
  {
    label: "Número",
    id: "number",
    sorting: "asc",
  },
  {
    label: "Proposta",
    id: "proposal",
  },
  {
    label: "Razão Social",
    id: "description",
    sorting: "disabled",
    style: {
      whiteSpace: "nowrap",
    },
    format: (item) => item ?? "Sem razão social",
  },
  {
    id: "emissionDate",
    label: "Data Emissão",
    minWidth: 125,
    sorting: "asc",
    format: (item) => moment(item).format("DD/MM/YYYY"),
  },
  {
    label: "Total (R$)",
    id: "amount",
    minWidth: 132,
    align: "right",
    sorting: "disabled",
    format: (item) => {
      return `${(item ?? 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 5,
      })}`;
    },
  },
  {
    label: "Modalidade",
    id: "modality",
  },
  {
    label: "Tipo de Serviço",
    id: "type",
  },
  {
    label: "Vigência",
    id: "effectiveDate",
    minWidth: 88,
    sorting: "disabled",
  },
  {
    label: "Status",
    id: "status",
  },
];

export const contractPeriod = {
  Todos: "all",
  ...periods,
};

export const dateType = {
  Emissão: "emissionDate",
  Vigência: "effectiveDate",
};

export const contractStatus = {
  Todos: null,
  Ativo: "active",
  Cancelado: "canceled",
  Suspenso: "suspended",
};

export const modality = {
  Todos: null,
  Recorrente: "recurrent",
  Avulso: "detached",
};

export const groupment = {
  "Sem agrupamento": null,
  Modalidade: "modality",
  Status: "status",
  "Tipo de Serviço": "type",
};

export const xlsxGroupEmptyDescription = {
  modality: "Sem modalidade",
  status: "Sem status",
  type: "Sem tipo de serviço",
};

export const sortIcon = {
  disabled: <ArrowUpward fontSize="inherit" color="disabled" />,
  asc: <ArrowUpward fontSize="inherit" color="primary" />,
  desc: <ArrowDownward fontSize="inherit" color="primary" />,
};

export const initialContractFilter = {
  multicompany: initialFilters.multicompany,
  period: contractPeriod.Todos,
  dateFilter: dateType.Emissão,
  status: contractStatus.Ativo,
  modality: modality.Todos,
  group: groupment["Sem agrupamento"],
  multipleSort: JSON.stringify([
    {
      column: "number",
      direction: "asc",
    },
    {
      column: dateType.Emissão,
      direction: "asc",
    },
  ]),
};
